import { render, staticRenderFns } from "./Debugger.vue?vue&type=template&id=0d80dbbb&"
import script from "./Debugger.vue?vue&type=script&lang=js&"
export * from "./Debugger.vue?vue&type=script&lang=js&"
import style0 from "./Debugger.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports